import { LoadingAnimation } from '@uag/react-core';
import { memo, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { SettingModelSettingType } from 'api/models';
import { CatalogueArticleTable } from 'app/modules/wallforming/components/catalogue-container/CatalogueArticleTable';
import { useGetArticleData } from 'app/modules/wallforming/components/catalogue-container/hooks/useGetArticleData';

interface CatalogueProps {
    settingType: SettingModelSettingType | undefined;
    showFilter?: boolean;
    children?: (props: { articleTableLoaded: boolean }) => ReactNode;
}

export const Catalogue = memo(({ settingType, showFilter = true, children }: CatalogueProps) => {
    // MIND: this component renders 3x (but CatalogueArticleTable only once)

    const { t } = useTranslation();
    const { articleData, isArticleDataPending } = useGetArticleData({ settingType });

    return (
        <div className="flex flex-col h-full align-middle overflow-hidden">
            {children?.({
                articleTableLoaded: !isArticleDataPending && articleData !== null && articleData.length > 0
            })}

            <div className="flex flex-col h-full align-middle overflow-hidden">
                <div className="flex flex-col h-full w-full overflow-hidden">
                    {isArticleDataPending && (
                        <div className="flex flex-1 items-center justify-center h-full">
                            <LoadingAnimation text={t('labelLoadArticleTable')} />
                        </div>
                    )}

                    {!isArticleDataPending && articleData && (
                        <CatalogueArticleTable articleData={articleData ?? []} showFilter={showFilter} />
                    )}
                </div>
            </div>
        </div>
    );
});

Catalogue.displayName = 'Catalogue';
